var map = {
	"./1. DashBoardOrganization.png": 4189,
	"./2.DashboardTeam.png": 6550,
	"./3. EmployeeCard.png": 7998,
	"./4. Profiling.png": 1593,
	"./5. BetherFrameWork.png": 2106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6818;